import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
import { add, isEmpty, map, size } from "lodash";
//import Lead from "./Lead";
import ClientLink from "./client-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import activityIcon from "../../assets/img/run-activity.png"
import compareIcon from "../../assets/img/compare-icon.png"
import {
  getClientDetail, addClientSellerShwoing, getClientSellerListing, getClientSellerShwoing,
  updateClientSellerShowing, deleteClientSellerShowing, getTransStatusType, getTransCommType,
  addClientSellerOffer, getClientSellerOffer, updateClientSellerOffer
} from "../../store/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardHeader,
  Table,
  Alert,
} from "reactstrap"
import BreadcrumbsClient from "../../components/Common/BreadcrumbClient";
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import UpdateButton from "components/buttons/updateBtn";
import RsLink from "components/buttons/rsLink";
import SaveButton from "components/buttons/save";
import ClientSellerBreadcrumbs from "components/Common/ClientSellerBreadcrumbClient";
import ClientSellerMenu from "./menu/client-seller-menu";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import NoAccess from "components/NoAccess";
import ClientEngagementList from "components/dropdowns/Lead/EngagementList";
import ClientEngagementListSeller from "components/dropdowns/Lead/EngagementListSeller";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import TimePicker from "components/dropdowns/Timepicker";
import CurrencyInput from "react-currency-input-field";
import moment from "moment";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import RsAdNew from "components/buttons/Adnew";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";
class ClientSellerShow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showing: '',
      allConditions: [],
      listing: "",
      expandedRow: null,
    }
    this.handleSellerShowingSubmit = this.handleSellerShowingSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleRightCanvas2 = this.toggleRightCanvas2.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggleSend = this.toggleSend.bind(this);
    this.canavasbuyeractivity = this.canavasbuyeractivity.bind(this);
    this.openOffer = this.openOffer.bind(this);
  }

  getStatus(id) {
    if (id === 4) return 'Offer Received';
    if (id === 5) return 'Offer Accepted';
    if (id === 6) return 'Offer Withdrawn';
    if (id === 20) return 'Offer Rejected';
  }

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (showing) => {
    this.setState({ showing: showing });
    this.setState({ deleteModal: true });
  };


    toggleOffer() {
    this.setState(prevState => ({
      isOffer: !prevState.isOffer
    }));
  }

  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }

  toggle2() {
    this.setState(prevState => ({
      isRight2: !prevState.isRight2
    }));
  }

  handleDeleteShowing = () => {
    const { onDeleteShowing } = this.props;
    const { showing } = this.state;

    if (showing.id !== undefined) {
      onDeleteShowing(showing);
      this.setState({ deleteModal: false });
      this.toggle();
    }
  };
  handleSellerShowingSubmit = (values, actions) => {
    //
    this.props.addClientSellerShwoing(values, (status)=>{
          if(status==true){
             actions.resetForm();
          }
    });
   
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientSellerListing, onGetClientSellerShowing, onGetTransactonStatusType, onGetTransactonCommType } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientSellerListing(params.id);
    onGetClientSellerShowing(params.id);
    onGetTransactonStatusType(localStorage.getItem('userId'), 'Seller');
    onGetTransactonCommType(localStorage.getItem('userId'));
    this.fetchClientActivity();
    this.fecthConditions();

    // const { listings, showings } = this.props;
    // const firstAvailable = listings.find((listing) =>
    //   showings.some((showing) => showing?.clientListing?.id === listing.id)
    // );
    //  if (firstAvailable) {
    //   
    //   this.setState({ listing: firstAvailable.id.toString() });
    // }
    //this.setDefaultListing();
  }
  setDefaultListing = () => {
    const { listings, showings } = this.props;
    const validListings = listings.filter((listing) =>
      showings.some((showing) => showing?.clientListing?.id === listing.id)
    );

    if (validListings.length > 0) {
      this.setState({ listing: validListings[0].id }); 
    }
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { showings } = this.props;
    if (!isEmpty(showings) && size(prevProps.showings) !== size(showings)) {
      this.setState({ showings: {}, isEdit: false });
    }
  }
  toggleSend() {
    this.setState({ isSend: !this.state.isSend });
    //this.toggle();
  }
  toggleRightCanvas() {
    this.setState({ showing: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }

  toggleRightCanvas2() {
    this.setState({ showing: "", isEdit: false, isRight2: !this.state.isRight2 });
    this.toggle2();
    //
  }



  toggleRightCanvas = arg => {
    const showing = arg;

    this.setState({
      showing: {

        id: showing.id,
        clientSellerShowingId: showing.clientSellerShowingId,
        clientId: showing.clientId,
        agentId: showing.agentId,
        clientListingId: showing.clientListingId,
        engagementId: showing?.clientListing?.engagementId,
        showingDate: showing.showingDate,
        startTime: showing.startTime,
        endTime: showing.endTime,
        agentName: showing.agentName,
        agentOrganization: showing.agentOrganization,
        agentContact: showing.agentContact,
        agentEmail: showing.agentEmail,
        feedback: showing.feedback,
        notificationMinutes: showing.notificationMinutes,
        isActive: true
      },
      isEdit: true,
    });
    this.toggle();
  };

  toggleRightCanvas2 = arg => {
    const showing = arg;
    const { onGetClientSellerOffer } = this.props;
     if (showing.id > 0) {
    onGetClientSellerOffer(showing.id);
     }
    this.setState({
      showing: {

        id: showing.id,
        clientSellerShowingId: showing.clientSellerShowingId,
        clientId: showing.clientId,
        agentId: showing.agentId,
        clientListingId: showing.clientListingId,
        showingDate: showing.showingDate,
        startTime: showing.startTime,
        endTime: showing.endTime,
        agentName: showing.agentName,
        agentOrganization: showing.agentOrganization,
        agentContact: showing.agentContact,
        agentEmail: showing.agentEmail,
        feedback: showing.feedback,
        notificationMinutes: showing.notificationMinutes,
        engagementId: showing?.clientListing?.engagementId,
        sellerType: showing?.clientEngagementInfo?.sellerType,
        isActive: true
      },
      isEdit: true,
    });
    this.toggle2();

  };
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        setFieldValue(`agentOfficeAddress`, place.formatted_address);

      })
      .catch(error => console.error('Error', error));
  };
  offerSubmitted = (values) => {
    const allConditions = this.state.allConditions;
    const agentId = parseInt(localStorage.getItem('userId'));
    const clientDealConditionStates = allConditions.map(condition => ({
      id: 0, // For new record
      clientDealConditionStateId: '68a459a7-384c-8331-84dd-4e59fb091ee2',
      clientDealConditionId: condition.id,
      clientListingId: parseInt(values.refId),
      clientOfferId: 0,
      clientId: parseInt(this.props.match.params.id),
      agentId: agentId,
      status: values.conditions.includes(condition.id.toString()),
      isActive: true
    }));
    const payload = {
      agentId: parseInt(localStorage.getItem('userId')),
      clientId: parseInt(this.props.match.params.id),
      partyName: values.partyName,
      partyAgentInfo: values.partyAgentInfo,
      agentName: values.agentName,
      agentMobile: values.agentMobile,
      agentEmail: values.agentEmail,
      agentOffice: values.agentOffice,
      agentOfficeName: values.agentOfficeName,
      agentOfficeAddress: values.agentOfficeAddress,
      agentOfficePhone: values.agentOfficePhone,
      transTypeId: 1,
      //commissionTypeId: parseInt(values.commissionTypeId),
      //commisisonValue: parseInt(values.commisisonValue),
      askingPrice: parseInt(values.askingPrice),
      offerPrice: values.offerPrice ? parseInt(values.offerPrice) : 0,
      expiryDate: values.expiryDate ? moment(values.expiryDate).format('YYYY-MM-DD') : null,
      expiryTime: values.expiryDate,
      deposit: values.deposit ? parseInt(values.deposit) : 0,
      offerDate: values.offerDate ? moment(values.offerDate).format('YYYY-MM-DD') : null,
      closingDate: values.closingDate ? moment(values.closingDate).format('YYYY-MM-DD') : null,

      agreementStartDate: values.agreementStartDate ? moment(values.agreementStartDate).format('YYYY-MM-DD') : null,
      agreementEndDate: values.agreementEndDate ? moment(values.agreementEndDate).format('YYYY-MM-DD') : null,
      refId: parseInt(values.refId),
      refTypeId: 2,
      statusId: parseInt(values.statusId),
      isAccepted: '',
      conditions: '',
      notes: values.notes,
      engagementId: parseInt(values.engagementId),
      clientName: values.clientName,
      clientMobile: values.clientMobile,
      clientPhone: values.clientPhone,
      clientEmail: values.clientEmail,
      clientDealConditionStates: clientDealConditionStates,
    }

    this.props.addClientSellerOffer(payload, (status) => {
      if (status == true) {
        this.toggle2();
      }
    });


  }
  offerUpdated = (values) => {
    const selectedConditions = this.props.selleroffer?.clientDealConditionStates || [];
    const allConditions = this.state.allConditions || [];
    const agentId = parseInt(localStorage.getItem('userId'), 10);
    const clientDealConditionStates = allConditions.map(condition => {
      const existingCondition = selectedConditions.find(c => c.clientDealConditionId === condition.id);

      return {
        id: existingCondition ? existingCondition.id : 0,
        clientDealConditionStateId: existingCondition ? existingCondition.clientDealConditionStateId : '68a459a7-384c-8331-84dd-4e59fb091ee2',
        clientDealConditionId: condition.id,
        clientListingId: parseInt(values.refId, 10),
        clientOfferId: parseInt(values.id, 10),
        clientId: parseInt(this.props.match.params.id, 10),
        agentId: agentId,
        status: values.conditions?.includes(condition.id.toString()) || false,
        isActive: true
      };
    });
    const payload = {
      id: parseInt(values.id),
      offerId: values.offerId,
      agentId: parseInt(localStorage.getItem('userId')),
      clientId: parseInt(this.props.match.params.id),
      partyName: values.partyName,
      partyAgentInfo: values.partyAgentInfo,
      agentName: values.agentName,
      agentMobile: values.agentMobile,
      agentEmail: values.agentEmail,
      agentOffice: values.agentOffice,
      agentOfficeName: values.agentOfficeName,
      agentOfficeAddress: values.agentOfficeAddress,
      agentOfficePhone: values.agentOfficePhone,
      transTypeId: 1,
      //commissionTypeId: parseInt(values.commissionTypeId),
      //commisisonValue: parseInt(values.commisisonValue),
      askingPrice: parseInt(values.askingPrice),
      offerPrice: values.offerPrice ? parseInt(values.offerPrice) : 0,
      offerDate: values.offerDate ? moment(values.offerDate).format('YYYY-MM-DD') : null,
      closingDate: values.closingDate ? moment(values.closingDate).format('YYYY-MM-DD') : null,
      expiryDate: values.expiryDate ? moment(values.expiryDate).format('YYYY-MM-DD') : null,
       agreementStartDate: values.agreementStartDate ? moment(values.agreementStartDate).format('YYYY-MM-DD') : null,
      agreementEndDate: values.agreementEndDate ? moment(values.agreementEndDate).format('YYYY-MM-DD') : null,
      expiryTime: values.expiryTime,
      deposit: values.deposit ? parseInt(values.deposit) : 0,
      refId: parseInt(values.refId),
      refTypeId: 2,
      statusId: parseInt(values.statusId),
      isAccepted: '',
      conditions: '',
      notes: values.notes,
      engagementId: parseInt(values.engagementId),
      clientName: values.clientName,
      clientMobile: values.clientMobile,
      clientPhone: values.clientPhone,
      clientEmail: values.clientEmail,
      clientDealConditionStates: clientDealConditionStates,
    }
    this.props.updateClientSellerOffer(payload, (status) => {
      if (status == true) {
        this.toggle2();
      }
    });

  }
  canavasbuyeractivity() {
    this.setState({ buyerActivity: "", isActivity: !this.state.isActivity });
  }
  getListingSubType = (type) => {
    if (type == 11)
      return 'Listing Added';
    else if (type == 12)
      return 'Scheduled';
    else if (type == 16)
      return 'Offer Received';
    else if (type == 17)
      return 'Offer Accepted';
    else if (type == 18)
      return 'Widthdrawn';
    else if (type == 19)
      return 'Rejected';
  }
  getType = (type) => {
    if (type == 1)
      return 'Buyer';
    else if (type == 2)
      return 'Seller';
    else if (type == 3)
      return 'Openhouse';
  }
  getSellerListingSubType = (type) => {
    if (type == 11)
      return 'Listing Added';
    else if (type == 12)
      return 'Scheduled';
    else if (type == 16)
      return 'Offer Received';
    else if (type == 17)
      return 'Offer Accepted';
    else if (type == 18)
      return 'Widthdrawn';
    else if (type == 19)
      return 'Rejected';
  }
  getOpenHouse = (type) => {
    if (type == 22)
      return 'Scheduled';
    else if (type == 23)
      return 'Updated';
  }
  fetchClientActivity() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const body = {
      agentId: parseInt(localStorage.getItem("userId")),
      clientId: parseInt(this.props.match.params.id),
      typeIds: [2, 3],
    };

    axios
      .post(`${API_URL}ClientListingActivity/allforagenttype`, body, { headers })
      .then((response) => {
        this.setState({ clientActivities: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  handleListingChange = (e) => {
    this.setState({ listing: e.target.value });
  };
  fecthConditions = () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return;
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;
    if (!token) return;
    const str = 'Bearer ' + token;
    axios.get(`${API_URL}ClientDealCondition/allforagenttype`, {
      params: {
        agentId: parseInt(localStorage.getItem("userId")),
        forType: 2
      },
      headers: { Authorization: str }
    })
      .then(res => this.setState({ allConditions: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }
    openOffer() {
    this.setState({  isOffer: !this.state.isOffer });
    this.toggleOffer();
  }
  openOffer(){
    //
    this.fetchOffer(this.state.listing || 0)
    this.toggleOffer();
  }
   fetchOffer(listingId) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const params = {
        listingId: listingId,
        agentId: parseInt(localStorage.getItem('userId')),
      }
      axios
        .get(`${API_URL}ClientOffer/GetSellerClientOffersByListingIdForCompare`, { headers, params })
        .then((response) => {
          this.setState({ offersData: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }

    toggleExpand = (index) => {
    this.setState({ expandedRow: this.state.expandedRow === index ? null : index });
  };
 renderStatus = (statusId) => {
    const status = this.getStatus(statusId);
    if (statusId === 4) return <span className="btnOfferRecieved">{status}</span>;
    if (statusId === 5) return <span className="btnOfferAccepted">{status}</span>;
    if (statusId === 6) return <span className="btnOfferWithdrawn">{status}</span>;
    if (statusId === 20) return <span className="btnOfferRejected">{status}</span>;
    return <span>{status}</span>;
  };

  renderActions = (showing) => (
    <>
      <Link to="#" className="btn btn-action" onClick={() => this.toggleRightCanvas(showing)}>
        Manage
      </Link>{" "}
      {(!showing.anyAcceptedOffer || (showing.anyAcceptedOffer && showing.transactionStatus?.title === "Offer Accepted")) ? (
        <Link to="#" className="btn btn-green" onClick={() => this.toggleRightCanvas2(showing)}>
          Offer
        </Link>
      ) : (
        <button className="btn btn-green-disabled" disabled>Offer</button>
      )}
      {showing.IsListingDeleteAllowed && (
        <ActionDelete onClick={() => this.onClickDelete(showing)} />
      )}
    </>
  );
  render() {

    const { listings, showings, clietDetail, onUpdateClientSellerShowing, loading, transStatusTypes, transactionCommTypes, selleroffer, userdetail, isResponsive } = this.props;
    const showing = this.state.showing;
    const { isEdit, deleteModal, allConditions, offersData, expandedRow  } = this.state;
    const hasSellerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 2);
    const formatTimeLabel = (date) =>
      date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

    const now = new Date();
    const start = formatTimeLabel(now);
    const end = formatTimeLabel(new Date(now.getTime() + 60 * 60 * 1000));
    const initialClientListingId = listings?.length === 1 ? listings[0].id : '';  

      const offers = offersData?.map(item => ({
  agent: item.agentName || item.partyName || "N/A",
  offerDate: item.offerDate
    ? new Date(item.offerDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  price: item.askingPrice ? `$${item.askingPrice.toLocaleString()}` : "N/A",
  deposit: item.deposit ? `$${item.deposit.toLocaleString()}` : "N/A",
  closingDate: item.closingDate
    ? new Date(item.closingDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  expiry: item.expiryDate
  ? `${new Date(item.expiryDate).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })} ${item.expiryTime || ""}`
  : "N/A",
  conditions: item.clientDealConditionStates
    ?.filter(c => c.status === true)
    .map(c => c.clientDealConditionTitle || `Condition ${c.clientDealConditionId}`)
})) || []; 
  const allConditionTitles = Array.from(
    new Set(offers.flatMap(o => o.conditions || []))
  );

//

    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}

        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteShowing}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            {hasSellerType ? (
              <Row>
                <Col sm='2' className="pe-0">
                  <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
                </Col>
                <Col sm='10' className="">
                  <Row className="project-header">
                    <Col sm="7">
                      <ClientSellerBreadcrumbs
                        title={this.props.t("Clients")}
                        breadcrumbItem={this.props.t(" Showing")}
                      />
                    </Col>
                    <Col sm="4" className="">
                      <h2 className="">{this.props.t(clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                    </Col>
                  </Row>
                  <ClientSellerMenu isResponsive={isResponsive} />
                  <Row>
                  

                    <Col xl="12">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{

                          clientListingId: "",
                          agentName:"",
                          agentOrganization: "",
                          agentContact: "",
                          agentEmail: "",
                          showingDate: null,
                          startTime: '',
                          endTime: '',
                          agentId: localStorage.getItem('userId'),
                          clientId: this.props.match.params.id
                        }}
                        validationSchema={Yup.object().shape({
                         clientListingId: listings?.length > 1 
                          ? Yup.string().required("This is Required") 
                          : Yup.string(),
                          showingDate: Yup.date().nullable().required("This is Required"),
                          startTime: Yup.string().nullable().required("This is Required"),
                          endTime: Yup.string().nullable().required("This is Required"),
                          agentEmail: Yup.string().email("Invalid email format").nullable(),


                        })}

                        onSubmit={this.handleSellerShowingSubmit}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Card className="border-full">
                              <CardBody>
                                <h5 className="card-title pheading">Add Showing</h5>

                                <Row>
                                  <Col sm="3">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="clientListingId">
                                        {this.props.t("Listing Id*")}
                                      </Label>
                                      <SafeField as="select" name="clientListingId" className={
                                        "form-control" +
                                        (errors.clientListingId && touched.clientListingId
                                          ? " is-invalid"
                                          : "")
                                      } onChange={handleChange}> 
                                        <option value="">Select</option> 
                                        {map(listings, (listing, listingskey) => (
                                          <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                                        ))}
                                      </SafeField>
                                      <ErrorMessage
                                        name="clientListingId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col sm="3">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="showingDate">
                                        {this.props.t("Date *")}
                                      </Label>
                                      <InputGroup>
                                        <Flatpickr
                                           value={values.showingDate || ""} 
                                          className={
                                            "form-control" +
                                            (errors.showingDate && touched.showingDate
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder=""

                                          onChange={(value) => setFieldValue('showingDate', value[0])}
                                          //onClose={() => setFieldTouched("showingDate", true)}
                                          options={{
                                            altInput: false,
                                            altFormat: "F j, Y",
                                            dateFormat: "Y-m-d",
                                            
                                          }}
                                        />
                                      </InputGroup>
                                      <ErrorMessage
                                        name="showingDate"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col sm="3">
                                    <FormGroup className="mb15">


                                      <TimePicker
                                        name="startTime"
                                        label="Start Time *"
                                        value={values.startTime}
                                        onChange={(val) => setFieldValue("startTime", val)}
                                        onBlur={() => setFieldTouched("startTime", true)}
                                        minTime={null}
                                        error={errors.startTime}
                                        touched={touched.startTime}
                                      />

                                      <ErrorMessage
                                        name="startTime"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col sm="3">
                                    <FormGroup className="mb15">

                                      <TimePicker
                                        name="endTime"
                                        label="End Time *"
                                        value={values.endTime}
                                        onChange={(val) => setFieldValue("endTime", val)}
                                        onBlur={() => setFieldTouched("endTime", true)}
                                        minTime={values.startTime}
                                        disabled={!values.startTime}
                                        error={errors.endTime}
                                        touched={touched.endTime}
                                      />

                                      <ErrorMessage
                                        name="endTime"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <h5 className="card-title">Agent Detail (Optional)</h5>

                                <Row>
                                  <Col sm="3">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="agentName">
                                        {this.props.t("Agent Name")}
                                      </Label>
                                      <SafeField
                                        name="agentName"
                                        onChange={handleChange}
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.agentName && touched.agentName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="agentName"
                                      />
                                      <ErrorMessage
                                        name="agentName"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col sm="3">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="agentOrganization">
                                        {this.props.t("Agent Organization")}
                                      </Label>
                                      <SafeField
                                        name="agentOrganization"
                                        onChange={handleChange}
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.agentOrganization && touched.agentOrganization
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="agentOrganization"
                                      />
                                      <ErrorMessage
                                        name="agentOrganization"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col sm="3">
                                   <PhoneInputField
                                      label="Agent Phone"
                                      name="agentContact"
                                      value={values.agentContact}
                                      setFieldValue={setFieldValue}
                                      error={errors.agentContact}
                                      touched={touched.agentContact}
                                      country="ca"
                                      required={false}
                                    />
                                   
                                  </Col>
                                  <Col sm="3">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="agentEmail">
                                        {this.props.t("Agent Email")}
                                      </Label>
                                      <SafeField
                                        name="agentEmail"
                                        onChange={handleChange}
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.agentEmail && touched.agentEmail
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="agentEmail"
                                      />
                                      <ErrorMessage
                                        name="agentEmail"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>

                                <SaveButton btnClass="btn btn-save">Save</SaveButton>
                              </CardBody>
                            </Card>



                          </Form>
                        )}
                      </Formik>

                      <Row>
                        <Col sm="12">
                          <Card className="border-full mt-4">
                            <CardHeader>
                              <div className="row">
                                <div className="col-sm-3" style={{width:300}}>
                                  <div className="btn-group rl-group-btn" role="group">
                                    <Link to="#" onClick={this.canavasbuyeractivity}>
                                      <button
                                        type="button"
                                        className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                                      >
                                        <span className="d-flex align-items-center gap-2">

                                          <span>Seller Activity</span>

                                          <img src={activityIcon} alt="Grid" style={{ height: 16 }} />
                                        </span>
                                      </button>
                                    </Link>
                                  </div>

                                    <div className="btn-group rl-group-btn" role="group">
                                    <Link to="#" onClick={this.openOffer}>
                                      <button
                                        type="button"
                                        className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                                      >
                                        <span className="d-flex align-items-center gap-2">

                                          <span>Compare Offer</span>

                                          <img src={compareIcon} alt="Grid" style={{ height: 16 }} />
                                        </span>
                                      </button>
                                    </Link>
                                  </div>

                                </div>
                                <Col sm="2" style={{width:125}}>
                                <label className="fom-label font-size-14" style={{marginTop:10, color:'#000'}}>Select Property</label>
                                </Col>
                                <Col sm="2">
                                  <select
                                      className="form-select select-filter"
                                      //value={this.state.listing}
                                      onChange={this.handleListingChange}
                                    >
                                      <option value="">All</option>
                                      {map(
                                        listings.filter((listing) =>
                                          showings.some((showing) => showing?.clientListing?.id === listing.id)
                                        ),
                                        (listing, listingskey) => (
                                          <option key={"_list_" + listingskey} value={listing.id}>
                                            {listing.mlsId} - {listing.listingAddress}
                                          </option>
                                        )
                                      )}
                                    </select>
                                </Col>
                                <div className="col-sm-4">

                                </div>
                                
                              </div>

                            </CardHeader>
                            <CardBody>


                              <h5 className="card-title">Showing</h5>
                              <div className="">
                             <table className="table table-nowrap mb-0">
        <thead>
          {isResponsive ? (
            <tr>
            
              <th>Listing Id</th>
              <th>Date</th>
              <th></th>
              <th></th>
            </tr>
          ) : (
            <tr>
              <th>#</th>
              <th>Listing Id</th>
              <th>Date Time</th>
              <th>Agent Name</th>
              <th>Agent Contact</th>
              <th>Agent Email</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          )}
        </thead>

        <tbody>
          {showings.map((showing, index) => (
            <React.Fragment key={index}>
              {/* Main Row */}
              <tr
                onClick={() => isResponsive && this.toggleExpand(index)}
                style={{ cursor: isResponsive ? "pointer" : "default" }}
              >
                {isResponsive ? (
                  <>
                    
                    <td>{showing?.clientListing?.mlsId}</td>
                    <td>
                      <Moment format="Do MMM">{showing.showingDate}</Moment>
                      <br />
                      {showing.startTime}-{showing.endTime}
                    </td>
                    <td> <td>{this.renderActions(showing)}</td></td>
                    <td style={{ textAlign: "right" }}>
                      {expandedRow === index ? "▲" : "▼"}
                    </td>
                  </>
                ) : (
                  <>
                    <th>{index + 1}</th>
                    <td>{showing?.clientListing?.mlsId}</td>
                    <td>
                      <Moment format="Do MMMM YYYY">{showing.showingDate}</Moment>
                      <br /> {showing.startTime}-{showing.endTime}
                    </td>
                    <td>{showing.agentName || "N/A"}</td>
                    <td>{showing.agentContact || "N/A"}</td>
                    <td>{showing.agentEmail || "N/A"}</td>
                    <td>{this.renderStatus(showing.statusId)}</td>
                    <td>{this.renderActions(showing)}</td>
                  </>
                )}
              </tr>

              {/* Expanded Row for Mobile */}
              {isResponsive && expandedRow === index && (
                <tr>
                  <td colSpan={4} className="bg-light p-2">
                    <div><strong>Agent:</strong> {showing.agentName || "N/A"}</div>
                    <div><strong>Contact:</strong> {showing.agentContact || "N/A"}</div>
                    <div><strong>Email:</strong> {showing.agentEmail || "N/A"}</div>
                    <div><strong>Status:</strong> {this.renderStatus(showing.statusId)}</div>
                    {/* <div className="mt-2">{this.renderActions(showing)}</div> */}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
                              
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                    </Col>

                  </Row>
                </Col>
              </Row>
            ) : (
              <NoAccess />

            )}
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
              style={{ width: 850 }}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Manage
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: showing.id,
                    clientSellerShowingId: showing.clientSellerShowingId,
                    clientId: showing.clientId,
                    agentId: showing.agentId,
                    clientListingId: showing.clientListingId,
                    showingDate: showing.showingDate,
                    startTime: showing.startTime,
                    endTime: showing.endTime,
                    agentName: showing.agentName,
                    agentOrganization: showing.agentOrganization,
                    agentContact: showing.agentContact,
                    agentEmail: showing.agentEmail,
                    feedback: showing.feedback,
                    notificationMinutes: showing.notificationMinutes,
                    isActive: true


                  }}
                  validationSchema={Yup.object().shape({
                    agentEmail: Yup.string().email("Invalid email format").nullable(),
                    //clientListingId: Yup.string().required("This is Required"),
                    //agentName: Yup.string().required("This is Required"),
                    //agentOrganization: Yup.string().required("This is Required"),
                    //agentOrganization: Yup.string().required("This is Required"),

                  })}

                  onSubmit={values => {
                    //
                    if (isEdit) {
                      const updateShowing = {
                        id: values.id,
                        clientSellerShowingId: values.clientSellerShowingId,
                        clientId: values.clientId,
                        agentId: values.agentId,
                        clientListingId: parseInt(values.clientListingId),
                        showingDate: moment(values.showingDate).format('YYYY-MM-DD'),
                        startTime: values.startTime,
                        endTime: values.endTime,
                        agentName: values.agentName,
                        agentOrganization: values.agentOrganization,
                        agentContact: values.agentContact,
                        agentEmail: values.agentEmail,
                        feedback: values.feedback,
                        notificationMinutes: values.notificationMinutes,
                        isActive: true
                      };

                      onUpdateClientSellerShowing(updateShowing, (status) => {
                        if (status == true) {
                          this.toggle();
                        }
                      });
                    } else {

                    }

                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >

                      {/* <h5 className="card-title">Showing Detail</h5> */}

                      <Row>
                        <Col sm="3">
                          <FormGroup className="mb-3">
                            <Label htmlFor="clientListingId">
                              {this.props.t("Listing Id")}
                            </Label>
                            <SafeField as="select" name="clientListingId" className={
                              "form-control" +
                              (errors.mlsURL && touched.mlsURL
                                ? " is-invalid"
                                : "")
                            } onChange={handleChange}>
                              <option value="">Select</option>
                              {map(listings, (listing, listingskey) => (
                                <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                              ))}
                            </SafeField>
                            <ErrorMessage
                              name="clientListingId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col sm="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="clientListingId">
                                  {this.props.t("Status")}
                                </Label>
                                <SafeField as="select" name="clientListingId" className={
                                  "form-control" +
                                  (errors.mlsURL && touched.mlsURL
                                    ? " is-invalid"
                                    : "")
                                } onChange={handleChange}>
                                  <option value="">Select</option>
                                  {map(listings, (listing, listingskey) => (
                                     <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                                  ))}
                                </SafeField>
                                <ErrorMessage
                                  name="clientListingId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col> */}
                        <Col sm="3">
                          <FormGroup className="mb-3">
                            <Label htmlFor="showingDate">
                              {this.props.t("Showing Date")}
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.showingDate && touched.showingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.showingDate}
                                onChange={(value) => setFieldValue('showingDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  minDate: 'today'
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col sm="3">
                          <TimePicker
                            name="startTime"
                            label="Start Time *"
                            value={values.startTime}
                            onChange={(val) => setFieldValue("startTime", val)}
                            onBlur={() => setFieldTouched("startTime", true)}
                            minTime={null}
                            error={errors.startTime}
                            touched={touched.startTime}
                          />
                        </Col>

                        <Col sm="3">
                          <TimePicker
                            name="endTime"
                            label="End Time *"
                            value={values.endTime}
                            onChange={(val) => setFieldValue("endTime", val)}
                            onBlur={() => setFieldTouched("endTime", true)}
                            minTime={values.startTime}
                            disabled={!values.startTime}
                            error={errors.endTime}
                            touched={touched.endTime}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="12">

                          <FormGroup className="mb-3">
                            <Label htmlFor="feedback" className="w-100">
                              {this.props.t("Showing feedback")}


                            </Label>
                            <div className="">
                              {["Seems interested", "Over budget", "Small for current needs", "Bigger for current needs", "Needs too much work"].map((text, idx) => (
                                <button
                                  type="button"
                                  key={idx}
                                  className="btn btn-outline-primary btn-sm me-2 mb-2"
                                  onClick={() => {
                                    setFieldValue('feedback', text);
                                  }}
                                >
                                  {text}
                                </button>
                              ))}
                            </div>
                            <SafeField
                              name="feedback"
                              onChange={handleChange}
                              as="textarea"
                              className={
                                "form-control" +
                                (errors.feedback && touched.feedback
                                  ? " is-invalid"
                                  : "")
                              }
                              id="feedback"
                              placeholder="Write a message"
                            />

                            <ErrorMessage
                              name="feedback"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>


                      </Row>

                      <h5 className="card-title">Seller Agent Detail (Optional)</h5>

                      <Row>
                        <Col sm="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentName">
                              {this.props.t("Agent Name")}
                            </Label>
                            <SafeField
                              name="agentName"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentName && touched.agentName
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentName"
                            />
                            <ErrorMessage
                              name="agentName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentOrganization">
                              {this.props.t("Agent Organization")}
                            </Label>
                            <SafeField
                              name="agentOrganization"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentOrganization && touched.agentOrganization
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentOrganization"
                            />
                            <ErrorMessage
                              name="agentOrganization"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                           <PhoneInputField
                              label="Agent Phone"
                              name="agentContact"
                              value={values.agentContact}
                              setFieldValue={setFieldValue}
                              error={errors.agentContact}
                              touched={touched.agentContact}
                              country="ca"
                              required={false}
                            />
                     
                        </Col>
                        <Col sm="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentEmail">
                              {this.props.t("Agent Email")}
                            </Label>
                            <SafeField
                              name="agentEmail"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentEmail && touched.agentEmail
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentEmail"
                            />
                            <ErrorMessage
                              name="agentEmail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>


                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Update</button>
                      
                      {/* <RsLink onClick={()=> this.onClickDelete(showing)}>Delete</RsLink> */}
                      </div>



                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isRight2}
              direction="end"
              toggle={this.toggleRightCanvas2}
              style={{ width: 800 }}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas2}>
                Offer Details
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: (selleroffer?.id) ? selleroffer?.id : 0,
                    clientListingId: showing.clientListingId,
                    showingDate: showing.showingDate,
                 
                    offerId: (selleroffer?.offerId) ? selleroffer?.offerId : '',
                    partyName: (selleroffer?.partyName) ? selleroffer?.partyName : '',
                    partyAgentInfo: (selleroffer?.partyAgentInfo) ? selleroffer?.partyAgentInfo : '',
                    agentName: (selleroffer?.agentName) ? selleroffer?.agentName : showing.agentName,
                    agentMobile: selleroffer?.agentMobile ?? showing.agentContact,
                    agentEmail: (selleroffer?.agentEmail) ? selleroffer?.agentEmail : showing.agentEmail,
                    agentOffice: (selleroffer?.agentOffice) ? selleroffer?.agentOffice : '',
                    agentOfficeName: (selleroffer?.agentOfficeName) ? selleroffer?.agentOfficeName : showing.agentOrganization,
                    agentOfficeAddress: (selleroffer?.agentOfficeAddress) ? selleroffer?.agentOfficeAddress : '',
                    agentOfficePhone: (selleroffer?.agentOfficePhone) ? selleroffer?.agentOfficePhone : '',
                    transTypeId: 1,
                    //commissionTypeId: (selleroffer?.commissionTypeId) ? selleroffer?.commissionTypeId : '',
                    //commisisonValue: (selleroffer?.commisisonValue) ? selleroffer?.commisisonValue : '',
                    askingPrice: (selleroffer?.askingPrice) ? selleroffer?.askingPrice : '',
                    //offerPrice: (selleroffer?.askingPrice) ? selleroffer?.askingPrice : '',
                    deposit: (selleroffer?.deposit) ? selleroffer?.deposit : null,
                    offerPrice: (selleroffer?.offerPrice) ? selleroffer?.offerPrice : null,
                    offerDate: (selleroffer?.offerDate) ? selleroffer?.offerDate : null,
                    closingDate: (selleroffer?.closingDate) ? selleroffer?.closingDate : null,
                    expiryDate: (selleroffer?.expiryDate) ? selleroffer?.expiryDate : null,
                    expiryTime:selleroffer?.expiryTime,

                     agreementStartDate: (selleroffer?.agreementStartDate) ? selleroffer?.agreementStartDate : null,
                    agreementEndDate: (selleroffer?.agreementEndDate) ? selleroffer?.agreementEndDate : null,

                    refId: (selleroffer?.refId) ? selleroffer?.refId : showing.id,
                    refTypeId: 2,
                    statusId: (selleroffer?.statusId) ? selleroffer?.statusId : 0,
                    isAccepted: '',
                    conditions: '',
                    notes: (selleroffer?.notes) ? selleroffer?.notes : '',
                    engagementId: showing.engagementId,
                    clientName: selleroffer?.clientName,
                    clientMobile: selleroffer?.clientMobile,
                    clientPhone: selleroffer?.clientPhone,
                    clientEmail: selleroffer?.clientEmail,
                    sellerType: showing?.sellerType,
                    conditions: allConditions
                      .filter(c => selleroffer?.clientDealConditionStates?.some(sc => sc.clientDealConditionId === c.id && sc.status === true))
                      .map(c => c.id.toString())
                  }}

                  validationSchema={Yup.object().shape({

                    //engagementId: Yup.string().required("This is Required")
                  })}
                  onSubmit={(values) => {
                    if (selleroffer && selleroffer.id) {
                      this.offerUpdated(values);
                    } else {
                      this.offerSubmitted(values);
                    }
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row>

                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="statusId">
                              {this.props.t("Offer Status")}
                            </Label>
                            <SafeField as="select" name="statusId"
                              className={
                                "form-control" +
                                (errors.statusId && touched.statusId
                                  ? " is-invalid"
                                  : "")
                              }

                              onChange={handleChange}>
                              <option value="">Select</option>
                              {map(transStatusTypes, (transStatusType, classkey) => (
                                <option value={transStatusType.id} key={classkey}>{transStatusType.title}</option>
                              ))}


                            </SafeField>
                            <ErrorMessage
                              name="statusId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <ClientEngagementListSeller name="engagementId" clientId={this.props.match.params.id} agentId={localStorage.getItem('userId')} typeId={2} statusId={0} isDisabled={true} />
                        </Col>


                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="clientListingId">
                              {this.props.t("Id/MLS#")}
                            </Label>
                            <SafeField as="select"
                              disabled={true}
                              name="clientListingId" className={
                                "form-control" +
                                (errors.mlsURL && touched.mlsURL
                                  ? " is-invalid"
                                  : "")
                              } onChange={handleChange}>
                              <option value="">Select</option>
                              {map(listings, (listing, listingskey) => (
                                <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                              ))}
                            </SafeField>
                            <ErrorMessage
                              name="clientListingId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="12">
                          <h4 style={{ paddingTop: 0 }}>Offer details</h4>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="offerDate">
                              {this.props.t("Receive date")}
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.offerDate && touched.offerDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.offerDate}
                              onChange={(value) => setFieldValue('offerDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                //minDate: 'today'
                              }}
                            />


                          </FormGroup>
                        </Col>
                         {values.sellerType==2 &&(
                                                  <>
                                                    <Col sm="4">
                                              <FormGroup className="mb-3">
                                                <Label htmlFor="agreementStartDate">
                                                  {this.props.t("Rental start date")}
                                                </Label>
                                                <Flatpickr
                                                  className={
                                                    "form-control" +
                                                    (errors.agreementStartDate && touched.agreementStartDate
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                  placeholder=""
                                                  value={values.agreementStartDate}
                                                  onChange={(value) => setFieldValue('agreementStartDate', value[0])}
                                                  options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"
                                                  }}
                                                />
                        
                        
                                              </FormGroup>
                                            </Col>
                                               <Col sm="4">
                                              <FormGroup className="mb-3">
                                                <Label htmlFor="agreementEndDate">
                                                  {this.props.t("Rental end date")}
                                                </Label>
                                                <Flatpickr
                                                  className={
                                                    "form-control" +
                                                    (errors.agreementEndDate && touched.agreementEndDate
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                  placeholder=""
                                                  value={values.agreementEndDate}
                                                  onChange={(value) => setFieldValue('agreementEndDate', value[0])}
                                                  options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"
                                                  }}
                                                />
                        
                        
                                              </FormGroup>
                                            </Col>
                                            </>
                                                )}
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="offerPrice">
                              {this.props.t("Offer Price")}
                            </Label>
                            <CurrencyInput
                              name="offerPrice"
                              value={values.offerPrice}
                              className="form-control"
                              onValueChange={(value) => setFieldValue('offerPrice', value)}
                              prefix={userdetail.agentDefaultCurrencyCode + " "}
                              decimalsLimit={2}


                            />


                            <ErrorMessage
                              name="offerPrice"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="deposit">
                              {this.props.t("Deposit amount")}
                            </Label>
                            <CurrencyInput
                              name="deposit"
                              value={values.deposit}
                              className="form-control"
                              onValueChange={(value) => setFieldValue('deposit', value)}
                              prefix={userdetail.agentDefaultCurrencyCode + " "}
                              decimalsLimit={2}
                            />


                            <ErrorMessage
                              name="askingPrice"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="closingDate">
                              {this.props.t("Closing Date")}
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.closingDate && touched.closingDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.closingDate}
                              onChange={(value) => setFieldValue('closingDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                minDate: 'today'
                              }}
                            />


                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="mb-3">
                            <Label htmlFor="offerExpiry">
                              {this.props.t("Offer expiry date")}
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.expiryDate && touched.expiryDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.expiryDate}
                              onChange={(value) => setFieldValue('expiryDate', value[0])}
                              options={{

                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                minDate: 'today'
                              }}
                            />


                          </FormGroup>
                        </Col>
                        <Col sm="3">
                            <TimePicker
                            name="expiryTime"
                            label="Time"
                            value={values.expiryTime}
                            onChange={(val) => setFieldValue("expiryTime", val)}
                            onBlur={() => setFieldTouched("expiryTime", true)}
                            minTime={null}
                            error={errors.expiryTime}
                            touched={touched.expiryTime}
                          />   
                        </Col>      
                        <Col sm="12">
                          <h4 style={{ paddingTop: 0 }}>Condition/clauses</h4>
                        </Col>
                        <Col sm="12">

                          {map(allConditions, (condition, index) => (
                            <div key={index} className="form-check form-check-inline">
                              <FormGroup className="mb-3">
                                <SafeField
                                  type="checkbox"
                                  name="conditions"
                                  value={condition.id.toString()}
                                  className="form-check-input"
                                  id={`condition-${index}`}
                                />
                                <label className="form-check-label" htmlFor={`condition-${index}`}>
                                  {condition.dealCondition}
                                </label>
                              </FormGroup>
                            </div>
                          ))}
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="notes">
                              {this.props.t("Special requests/clauses/conditions/notes")}
                            </Label>
                            <textarea
                              name="notes"
                              onChange={handleChange}
                              type="textarea"
                              value={values.notes}
                              className={
                                "form-control" +
                                (errors.notes && touched.notes
                                  ? " is-invalid"
                                  : "")
                              }
                              id="notes"
                            />
                            <ErrorMessage
                              name="notes"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                        </Col>





                        {/* <Col sm="4">
                        <FormGroup className="mb-3">
                            <Label htmlFor="depositPrice">
                              {this.props.t("Deposit")}
                            </Label>
                            <SafeField
                              name="depositPrice"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.depositPrice && touched.depositPrice
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="depositPrice"
                            />
                             <ErrorMessage
                              name="depositPrice"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col> */}
                        <h4 style={{ paddingTop: 0 }}>Buyer info</h4>
                        <Row>
                          <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="buyerName">{this.props.t("Buyer name")}</Label>
                              <SafeField type="text" name="partyName" className="form-control" />
                              <ErrorMessage name="partyName" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                          <h4 style={{ paddingTop: 0 }}>Agent info</h4>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentName">{this.props.t("Agent Name")}</Label>
                              <SafeField type="text" name="agentName" className="form-control" />
                              <ErrorMessage name="agentName" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentOfficeName">{this.props.t("Office name")}</Label>
                              <SafeField type="text" name="agentOfficeName" className="form-control" />
                              <ErrorMessage name="agentOfficeName" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                             
                               <PhoneInputField
                                                      label="Phone"
                                                      name="agentMobile"
                                                      value={values.agentMobile}
                                                      setFieldValue={setFieldValue}
                                                      error={errors.agentMobile}
                                                      touched={touched.agentMobile}
                                                      country="ca"
                                                      required={false}
                                                    />
                              <ErrorMessage name="agentMobile" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentEmail">{this.props.t("Email")}</Label>
                              <SafeField type="text" name="agentEmail" className="form-control" />
                              <ErrorMessage name="agentEmail" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                        </Row>

                        {/* <h4 style={{ paddingTop: 0 }}>Client Info</h4>
                                            <Row>
                                              <Col sm="6">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor="clientName">{this.props.t("Name")}</Label>
                                                  <SafeField type="text" name="clientName" className="form-control" />
                                                  <ErrorMessage name="clientName" component="div" className="invalid-feedback" />
                                                </FormGroup>
                                              </Col>
                                              <Col sm="6">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor="clientEmail">{this.props.t("Email")}</Label>
                                                  <SafeField type="text" name="clientEmail" className="form-control" />
                                                  <ErrorMessage name="clientEmail" component="div" className="invalid-feedback" />
                                                </FormGroup>
                                              </Col>
                                              <Col sm="6">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor="clientMobile">{this.props.t("Primary Phone")}</Label>
                                                  <SafeField type="text" name="clientMobile" className="form-control" />
                                                  <ErrorMessage name="clientMobile" component="div" className="invalid-feedback" />
                                                </FormGroup>
                                              </Col>
                                              <Col sm="6">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor="clientPhone">{this.props.t("Secondary Phone")}</Label>
                                                  <SafeField type="text" name="clientPhone" className="form-control" />
                                                  <ErrorMessage name="clientPhone" component="div" className="invalid-feedback" />
                                                </FormGroup>
                                              </Col>
                                            </Row>     */}
                        {/* <Col sm="6">
                                               <FormGroup className="mb-3">
                                                   <Label htmlFor="commissionTypeId">
                                                     {this.props.t("Commision Type")}
                                                   </Label>
                                                   <SafeField as="select" name="commissionTypeId" id="commissionTypeId"  className={
                                                           "form-control" +
                                                           (errors.commision_type && touched.commision_type
                                                             ? " is-invalid"
                                                             : "")
                                                         }
                                                         onChange={handleChange}>
                                                       <option value="">Select</option>
                                                       {map(transactionCommTypes, (transactionCommType, classkey) => (
                                                       <option value={transactionCommType.id} key={classkey}>{transactionCommType.title}</option>
                                                     ))}
                                                      
                                                     </SafeField>
                                                    <ErrorMessage
                                                     name="commissionTypeId"
                                                     component="div"
                                                     className="invalid-feedback"
                                                   />
                                                 </FormGroup>
                                              
                                               </Col>
                       
                       
                                               <Col sm="6">
                                               <FormGroup className="mb-3">
                                                   <Label htmlFor="commisisonValue">
                                                     {this.props.t("Commission value ")}
                                                   </Label>
                                                   <SafeField
                                                     name="commisisonValue"
                                                     onChange={handleChange}                            
                                                     type="text"
                                                     
                                                     className={
                                                       "form-control" +
                                                       (errors.commisisonValue && touched.commisisonValue
                                                         ? " is-invalid"
                                                         : "")
                                                     }
                                                    
                                                     id="mls"
                                                   />
                                                    <ErrorMessage
                                                     name="commisisonValue"
                                                     component="div"
                                                     className="invalid-feedback"
                                                   />
                                                 </FormGroup>
                                              
                                               </Col> */}





                        {/* <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="notes">
                              {this.props.t("Note")}
                            </Label>
                            <textarea
                              name="notes"
                              onChange={handleChange}
                              type="textarea"
                              value={values.notes}
                              className={
                                "form-control" +
                                (errors.notes && touched.notes
                                  ? " is-invalid"
                                  : "")
                              }
                              id="notes"
                            />
                             <ErrorMessage
                              name="notes"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                       
                        </Col> */}
                        <Col sm="12">
                          <div className="clearfix">
                            <UpdateButton>{this.props.t("Update")}</UpdateButton>{" "} <RsLink onClick={this.toggleRightCanvas2}>Close</RsLink>
                          </div>
                        </Col>
                      </Row>

                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isSend}
              direction="end"
              toggle={this.toggleSend}
            >
              <OffcanvasHeader toggle={this.toggleSend}>
                Send Document
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{


                  }}
                  validationSchema={Yup.object().shape({
                    documentTitle: Yup.string().max(50, "Title must not exceed 50").required("This is Required")
                  })}

                  onSubmit=""
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >


                      <Row>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="documentTitle">
                              {this.props.t("Subject")}
                            </Label>
                            <SafeField
                              name="emailSubject"
                              onChange={handleChange}
                              type="text"

                              className={
                                "form-control" +
                                (errors.emailSubject && touched.emailSubject
                                  ? " is-invalid"
                                  : "")
                              }

                              id="emailSubject"
                            />
                            <ErrorMessage
                              name="emailSubject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup>
                            {/* <h6 style={{ marginTop: 30 }}>

                                <strong>{this.props.t("Content")}</strong>
                              </h6> */}
                            <Label htmlFor="projectAdditionalFeatureDescription">Email Content</Label>
                            <CKEditor
                              editor={ClassicEditor}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('emailContent', data);
                              }}

                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">

                          <UpdateButton iconClass="bx bx-send">{this.props.t("Send")}</UpdateButton>{" "}

                        </Col>
                      </Row>


                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isActivity}
              direction="end"
              toggle={this.canavasbuyeractivity}
              style={{ width: 950 }}
            >
              <OffcanvasHeader toggle={this.canavasbuyeractivity}>
                Seller Activity
              </OffcanvasHeader>
              <OffcanvasBody>
                <DataTable
                  className=""
                  stripedRows
                  value={this.state.clientActivities}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  tableStyle={{ minWidth: "50rem" }}
                >
                  <Column
                    headerClassName="header-bg-table"
                    field="showingDate"
                    header="Date"
                    body={(rowData) =>
                      rowData.addedDate ? <Moment format="DD MMM, YYYY">{rowData.addedDate}</Moment> : "N/A"
                    }
                  />

                  <Column headerClassName="header-bg-table" field="clientListingActivityListing" header="Listing Id" body={(rowData) => rowData.clientListingActivityListing || "N/A"} />

                  {/* <Column  headerClassName="header-bg-table" field="clientListingActivityListingAddress" header="Listing Address" body={(rowData) => rowData.clientListingActivityListingAddress} /> */}

                  <Column
                    headerClassName="header-bg-table"
                    field="clientListingActivityType"
                    header="Type"
                    body={(rowData) => this.getType(rowData.clientListingActivityType) || "N/A"}
                  />
                  <Column
                    headerClassName="header-bg-table"
                    field="clientListingActivitySubType"
                    header="Sub Type"
                    body={(rowData) => {
                      const type = rowData.clientListingActivityType;
                      const subType = rowData.clientListingActivitySubType;

                      if (type === 1) {
                        return this.getListingSubType(subType) || "N/A";
                      } else if (type === 2) {
                        return this.getSellerListingSubType(subType) || "N/A";
                      } else {
                        return this.getOpenHouse(subType) || "N/A";
                      }
                    }}
                  />
                </DataTable>


              </OffcanvasBody>
            </Offcanvas>
              <Offcanvas
              isOpen={this.state.isOffer}
              direction="end"
              toggle={this.openOffer}
              style={{width:800}}
            >
              <OffcanvasHeader toggle={this.openOffer}>
                Compare Offer
              </OffcanvasHeader>
              <OffcanvasBody>
                {this.state.listing > 0 ? (
                  <>
                   <Table bordered responsive>
        <thead>
          <tr>
            <th>Overview</th>
            {offers.map((o, i) => (
              <th key={i} className="">{o.agent}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Offer date</td>
            {offers.map((o, i) => <td key={i}>{o.offerDate}</td>)}
          </tr>
          <tr>
            <td>Offer Price</td>
            {offers.map((o, i) => <td key={i}>{o.price}</td>)}
          </tr>
          <tr>
            <td>Deposit amount</td>
            {offers.map((o, i) => <td key={i}>{o.deposit}</td>)}
          </tr>
          <tr>
            <td>Closing Date</td>
            {offers.map((o, i) => <td key={i}>{o.closingDate}</td>)}
          </tr>
          <tr>
            <td>Offer expiry date/time</td>
            {offers.map((o, i) => <td key={i}>{o.expiry}</td>)}
          </tr>

          {/* Divider row for Conditions */}
          <tr className="">
            <td colSpan={offers.length + 1}><strong>Conditions</strong></td>
          </tr>
          {allConditionTitles.map((title, idx) => (
          <tr key={idx}>
            <td>{title}</td>
            {offers.map((o, i) => (
              <td key={i}>{o.conditions.includes(title) ? "✔️" : ""}</td>
            ))}
          </tr>
        ))}
        </tbody>
                    </Table>
                  </>
                ):(
                  <>
                    <Alert color="danger">&quot;Please select property first&quot; if the Select property is set to &quot;All&quot;</Alert>
                  </>
                )}
                    
              </OffcanvasBody>
              </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientSellerShow.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  addClientSellerShwoing: PropTypes.func,
  onGetClientSellerListing: PropTypes.func,
  listings: PropTypes.array,
  onGetClientSellerShowing: PropTypes.func,
  showings: PropTypes.array,
  match: PropTypes.object,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,
  onDeleteShowing: PropTypes.func,
  onUpdateClientSellerShowing: PropTypes.func,
  loading: PropTypes.object,
  onGetTransactonStatusType: PropTypes.func,
  transStatusTypes: PropTypes.array,
  onGetTransactonCommType: PropTypes.func,
  transactionCommTypes: PropTypes.array,
  addClientSellerOffer: PropTypes.func,
  onGetClientSellerOffer: PropTypes.func,
  selleroffer: PropTypes.object,
  updateClientSellerOffer: PropTypes.func,
  userdetail: PropTypes.object,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({ Clients, AppoinmentObject }) => (
  {
    clietDetail: Clients.clietDetail,
    listings: Clients.listings,
    showings: Clients.showings,
    loading: Clients.loading,
    transStatusTypes: AppoinmentObject.transStatusTypes,
    transactionCommTypes: AppoinmentObject.transactionCommTypes,
    selleroffer: Clients.selleroffer
  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientSellerShwoing: (data, callback) => dispatch(addClientSellerShwoing(data, callback)),
  onGetClientSellerListing: (clientId) => dispatch(getClientSellerListing(clientId)),
  onGetClientSellerShowing: (clientId) => dispatch(getClientSellerShwoing(clientId)),
  onUpdateClientSellerShowing: (data, callback) => dispatch(updateClientSellerShowing(data, callback)),
  onDeleteShowing: id => dispatch(deleteClientSellerShowing(id)),
  onGetTransactonStatusType: (agentId, forType) => dispatch(getTransStatusType(agentId, forType)),
  onGetTransactonCommType: (agentId) => dispatch(getTransCommType(agentId)),
  addClientSellerOffer: (data, callback) => dispatch(addClientSellerOffer(data, callback)),
  onGetClientSellerOffer: (refId) => dispatch(getClientSellerOffer(refId)),
  updateClientSellerOffer: (data, callback) => dispatch(updateClientSellerOffer(data, callback))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientSellerShow))
